module.exports = __webpack_public_path__ + "static/media/background.119d8d9b.png";